import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Select } from './components';
import ReactCountryFlag from "react-country-flag"
import styled from "styled-components";
import {useGetCurrentUserQuery} from "../api/userApiSlice";
import SearchItem from './SearchItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-light-svg-icons'

const NoCaretDropdown = styled.div`
    .dropdown-toggle:after {
      content: none !important;
    }
  `

function Searchbar(props) {
  const { t, i18n } = useTranslation();
  const {data: {firstName, lastName, isAdmin} = {}, isSuccess} = useGetCurrentUserQuery()

  const setLanguage = code => {
    i18n.changeLanguage(code);
  };

  const codes = {
    "fr": "FR",
    "en": "GB",
  }

  const defaultDropdownFlagStyle = {
    marginBottom: '0.2em'
  }

  return (
    <nav className="navbar page-header navbar-expand-lg navbar-inverse navbar-fixed-top">
      <button type="button" className="btn navbar-btn navbar-left" id="toggle-side-menu-button" onClick={props.handleOnClick}>
        <FontAwesomeIcon icon={faBars} size="2x"/>
      </button>
      { isAdmin && <SearchItem/> }
      { !isAdmin && <div className="mx-2 my-auto d-inline w-100"/> }
      <div className= "navbar-nav" id="nav-lang">
        <div className="dropdown dropdown-dark nav-item">
          <a className="dropdown-toggle nav-link" id="lang-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <ReactCountryFlag countryCode={codes[i18n.language.split('-')[0]] || "FR"} svg style={{
                fontSize: '1.2em',
                marginBottom: '0.2em',
                marginRight: '0.2em',
                width: '1.2em,'
            }}/>
            <span className="caret"/>
          </a>
          <div className="dropdown-menu" aria-labelledby="lang-menu">
            {i18n.language !== 'fr' && <a className="dropdown-item" rel="nofollow" onClick={() => setLanguage('fr')} >
              <ReactCountryFlag countryCode="FR" svg style={defaultDropdownFlagStyle} /> Français
            </a>}
            {i18n.language !== 'en' && <a className="dropdown-item" rel="nofollow" onClick={() => setLanguage('en')} >
              <ReactCountryFlag countryCode="GB" svg style={defaultDropdownFlagStyle} /> English
            </a>}
          </div>
        </div>
      </div>

      <div className= "navbar-nav" id="nav-user">
        <NoCaretDropdown className="dropdown dropdown-dark nav-item">
          <a className="dropdown-toggle nav-link" id="user-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span align="center" className="username username-hide-on-mobile">
              {`${firstName} ${lastName}`}
            </span>
            <Icon icon={'user-circle'} size={'2x'} style={{verticalAlign: "middle", marginLeft: "5px"}}/>
          </a>
          <div className="dropdown-menu"  aria-labelledby="user-menu">
            <a className="dropdown-item" rel="nofollow" data-turbo-method="delete" href="/user/sign_out">
              <Icon icon={'key'} text={t('logout')} />
            </a>
          </div>
        </NoCaretDropdown>
      </div>
    </nav>
  )
}

export default Searchbar
